import { getQuery, isMobile } from '@tencent/pa-cms-utils';
import { clearLoginCookie, getLoginCookie, setLoginCookie } from "./cookie";
import { isInIntlBrowser, appendScript, appendLink, getSpecialBrowserType, urlparamsToObject } from "./tools";
import { game_id, ACCOUNT_APP_ID, channel_map, isHtm } from "./const";
import { reportTlog } from '@/api/modules/report';
/**
 * 检查登录
 * @description encodeparam 为游戏内打开时从注入的登录态
 */
export function checkLogin() {
  const data = getLoginCookie();
  const { openid, token, encodeparam } = data;
  return (!!openid && !!token) || (Boolean(encodeparam) && isInIntlBrowser);
}
const testLipSdk = 'https://test-common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.umd.js';
const testLipCss = 'https://test-common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.css';
const prodLipSdk = 'https://common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.umd.js';
const prodLipCss = 'https://common-web.intlgame.com/sdk-cdn/infinite-pass/latest/index.css';

function combieLoginCookie(loginInfo: Record<string, string>, channel: string) {
  return Object.assign({}, loginInfo, { game_id: game_id, channel })
}
const info = () => {
  const data = getLoginCookie();
  return data;
};
const addSrc = async () => {
  if ((window as any).PassFactory) return;
  const src = prodLipSdk;
  const link = prodLipCss;
  await Promise.all([appendScript(src), appendLink(link)])
}

window.requestIdleCallback?.(addSrc)
async function init() {
  const channel = getQuery("channelid");
  if (getQuery("encodeparam") ) {
    const url_obj = urlparamsToObject();
    setLoginCookie(
      Object.assign({}, url_obj, {
        channel: channel,
        game_id: url_obj.gameid,
        expires: (Number(url_obj.ts) + 60 * 60 * 24 * 30 )* 1000,
        // 角色验证相关
        zone_id: url_obj.zone_id,
        lang_type: url_obj.lang_type,
        area_id: url_obj.area_id,
        role_id: url_obj.role_id,
        // role_name: url_obj.user_name,
      })
    );
    return;
  }
}

const login = async (lang: string) => {
  if (checkLogin()) {
    return info();
  }

  try{
    return await showLogin({ lang });
    // window.location.reload()
  } catch {}
};

const socialLists = isMobile() ?  ["google", "facebook", "apple", "twitter" ] :  ["google", "facebook", "apple", "twitter", "line" ];
const showLogin = async (loginParam: Record<string, any>) => {
  return new Promise<Record<string, string>>(async (resolve, reject) => {
    await addSrc();
    const loginLangMap = {
      tw: 'zh-TW',
      ja: 'ja',
      ko: 'ko',
      zh: 'zh-Hans',
      th: 'th',
      en: 'en',
      id: 'id',
    }
    const browser = getSpecialBrowserType();
    // facebook 和line 端内屏蔽 现有的 第三方 登录
    const socialList = ['facebook', 'line', 'ins', 'kakao', 'naver'].includes(browser)  ? [] : socialLists;
    const pass = new (window as any).PassFactory.Pass({
      env: isHtm ? 'sg' : 'aws-na', // environment
      gameID: game_id, // gameid
      appID: ACCOUNT_APP_ID, // account App ID

      config: {
        langType: loginLangMap[loginParam.lang as keyof typeof loginLangMap],
        isMobile: isMobile(),
        renderMode: 'modal',
        socialList,
      },
    });
    reportTlog({
      action: "red_lotus_login_page",
      sub_action: "cm_vshow",
    })
    // mount pass component
    pass.start("#login")
    pass.on('onLoginError',(error: { ret: number }) => {
      console.log("error: ", error);
    })
    pass.on('onLogin',(userInfo: Record<string, any>) => {
      const { channel_info } = userInfo;
      setLoginCookie(combieLoginCookie(userInfo, channel_info.channelId));
      resolve(userInfo);
      reportTlog({
        action: "red_lotus_login_success",
        sub_action: "cm_click",
        ext_content: {
          channel_name: channel_info.channelId,
        }
      })
      pass.unmount();
    });
  })
};

const logout = async () => {
  clearLoginCookie()
  return;
};
export default {
  checkLogin,
  login,
  info,
  showLogin,
  logout,
  init
};
